import React from "react";
import { Link } from "react-router-dom";
import "../service.css"; 
import imageTravauxPublics from "../assets/Réglage-min.jpeg";
import imageGénieCivil from "../assets/assainissement-min.jpeg";
import imageEspaceVert from "../assets/pave.jpeg";

const Service = () => {
  return (
    <div className="service-container">
      <div className="service-grid">
        <div className="service-item">
          <h2 className="titre-item">Travaux publics</h2>
          <div className="service-content">
            <p>Aménagements urbains</p>
            <Link to="/nos-metiers#travaux-publics">
              <button className="info-button">Plus d'infos</button>
            </Link>
          </div>
          <img src={imageTravauxPublics} alt="Travaux publics" className="service-image" />
        </div>

        <div className="service-item">
          <h2 className="titre-item">Génie civil</h2>
          <div className="service-content">
            <p>Infrastructures urbaines Assainissement</p>
            <Link to="/nos-metiers#genie-civil">
              <button className="info-button">Plus d'infos</button>
            </Link>
          </div>
          <img src={imageGénieCivil} alt="Génie civil" className="service-image" />
        </div>

        <div className="service-item">
          <h2 className="titre-item">Espace vert</h2>
          <div className="service-content">
            <p>Aménagement</p>
            <Link to="/nos-metiers#espace">
              <button className="info-button">Plus d'infos</button>
            </Link>
          </div>
          <img src={imageEspaceVert} alt="Espace vert" className="service-image" />
        </div>
      </div>
    </div>
  );
};

export default Service;
